import React from 'react';

export default function TechSpecsTab() {
	return <div style={{ minHeight: '200px', padding: '2em' }}>TechSpecs</div>;
}
